import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../TextInput';

const ImageUpload = React.forwardRef((props, ref) => (
  <TextInput innerRef={ref} {...props} />
));

export default ImageUpload;

ImageUpload.propTypes = {
  ref: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
